import { Title } from '@QuizComponents/Title';
import { RadioButton } from '@Components/RadioButton';
import { useDispatch, useSelector } from 'react-redux';
import { useContext, useEffect } from 'react';
import { updateQuizProgressBar } from '@Store/components/quiz/actions/quizAction';
import { QuizContext } from '@Pages/Quiz/Quiz';
import { SubTitle } from '@QuizComponents/SubTitle';
import { radioButtonsData } from './radioButtonsData';
import { sendAmplitudeData } from '@Analytics/amplitude';

export const Medication = ({ subStepName, handleRadioButton }) => {
  const quiz = useSelector((store) => store.quiz);
  const dispatch = useDispatch();
  const setCurrentStepName = useContext(QuizContext).setCurrentStepName;

  useEffect(() => {
    dispatch(
      updateQuizProgressBar({
        stepName: 'step4',
        currentStep: 8,
        totalSteps: 8,
      })
    );
    sendAmplitudeData('Step_4_10_Medications_view');
  }, []);

  useEffect(() => {
    setCurrentStepName('step4');
  }, []);

  return (
    <>
      <Title title='Medication' />
      <SubTitle style={{ margin: '20px' }} text={'Are you currently taking any of the following supplements/medications? Select all that apply.'} />
      {radioButtonsData.map(({ value }) => {
        return (
          <RadioButton
            key={value}
            id={value}
            text={value}
            name={subStepName}
            checked={quiz['medication'] === value}
            onClick={handleRadioButton}
            value={value}
          />
        );
      })}
    </>
  );
};
